import qs from 'qs'
import { EndpointQueryParameters } from '../../types/strapi/strapi'

export default function getQuery(url: string) {
    return (params: EndpointQueryParameters | void) => {
        const paramsString = qs.stringify(params, { addQueryPrefix: true })
        return `${url}${paramsString}`
    }
}
